var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.9286,
    y: 21.78,
    width: 22,
    height: 21,
    rx: 5,
    transform: "rotate(180 22.9286 21.78)",
    fill: "#EEFDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 8.98832L9.42859 13.5717",
    stroke: "#4AF06F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 13.5717L9.42859 13.5717L9.42859 8.98832",
    stroke: "#4AF06F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeArrow);
export default __webpack_public_path__ + "static/media/incomeArrow.67555c7632e961b4d18e509eac127489.svg";
export { ForwardRef as ReactComponent };